export var ArticleType;
(function (ArticleType) {
    ArticleType["Growth"] = "growth";
    ArticleType["Efficiency"] = "efficiency";
    ArticleType["Attainment"] = "attainment";
})(ArticleType || (ArticleType = {}));
//# sourceMappingURL=articleType.js.map